// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__MVerI","show":"BackToTop_show__LR-PO"};